import { ItinerantsTemplate } from "../../Templates/ItinerantsTemplate";

export const Itinerants = () => {
  return <ItinerantsTemplate />;
};
